module.exports = function getResource(label, vars = []) {
    let resources = {
        continueToCheckoutButton: 'Continue to Checkout',
        checkoutWithApplePayButton: 'Checkout with Apple Pay',
        applePayButton: 'Apple Pay',
        checkoutButton: 'Checkout'
    };

    return resources[label];
};
